import React, { useContext } from "react";
import Flex from "common/Boxes/Flex";
import TargetsSection from "features/signals/SignalDrawer/Targets/TargetsSection/TargetsSection";
import LoadingSpinnerOverlay from "common/Overlays/LoadingSpinnerOverlay";
import { EditSignalContext } from "features/signals/EditSignal/EditSignal.context";
import { SignalDetailsContext } from "@shared/features/signals/common/SignalDetails.context";
import SignalChart from "features/signals/SignalDrawer/SignalChart";
import useMedia from "utils/hooks/useMedia";
import { SMALL_SCREEN } from "common/constants";

const TargetsPage = ({ signalExchangeArgs, exchanges, symbol }) => {
  const { isEdit, editSignalLoading } = useContext(EditSignalContext)!;
  const {
    generalDataQuery,
    getSignalExtraInfoTargetsQuery,
    getMostFulfilledSignalForGroupQuery,
  } = useContext(SignalDetailsContext)!;

  const isSmallScreen = useMedia(
    [`(max-width: ${SMALL_SCREEN})`],
    [true],
    false
  );

  const isLoading =
    getSignalExtraInfoTargetsQuery.isLoading ||
    generalDataQuery.isLoading ||
    getMostFulfilledSignalForGroupQuery.isLoading;

  return (
    <LoadingSpinnerOverlay
      isLoading={isLoading || editSignalLoading}
      spinnerMarginTop={50}
      hideContentWhileLoading={isLoading}
    >
      <Flex $flexDirection="column" $alignItems="center">
        {isSmallScreen && <SignalChart symbol={symbol} exchanges={exchanges} />}
        <TargetsSection args={signalExchangeArgs} isEdit={isEdit} />
      </Flex>
    </LoadingSpinnerOverlay>
  );
};

export default TargetsPage;
